export const RetryIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '18'}
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.833496 2.33136V7.33136M0.833496 7.33136H5.8335M0.833496 7.33136L4.70016 3.69803C5.59579 2.80196 6.70381 2.14737 7.92084 1.79534C9.13787 1.44331 10.4242 1.40532 11.6599 1.68491C12.8956 1.9645 14.0403 2.55256 14.9873 3.39421C15.9342 4.23586 16.6525 5.30368 17.0752 6.49803M19.1668 15.6647V10.6647M19.1668 10.6647H14.1668M19.1668 10.6647L15.3002 14.298C14.4045 15.1941 13.2965 15.8487 12.0795 16.2007C10.8625 16.5527 9.57608 16.5907 8.3404 16.3111C7.10472 16.0316 5.96 15.4435 5.01305 14.6018C4.06611 13.7602 3.3478 12.6924 2.92516 11.498"
      stroke={props?.color || '#344054'}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
